import * as React from "react";
import { Accordion, AccordionItem } from "@grandvisionhq/common";
import { H4 } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
import { useCart } from "../../../../context/Cart/context/Cart/context.js";
import { AppliedDiscounts } from "../../AppliedDiscounts/modules/VoucherCodes/AppliedDiscounts/AppliedDiscounts.js";
import { VoucherCodeFormContainer } from "../../VoucherCodeForm/modules/VoucherCodes/VoucherCodeForm/VoucherCodeFormContainer.js";
/* empty css                        */
const VoucherCodesLayout = ({ isReadOnly }) => {
  const { getLabel } = useIntl();
  const { cart } = useCart();
  if (!cart) return null;
  const appliedDiscounts = isReadOnly ? cart.appliedCartDiscounts?.filter((discount) => discount.type !== "UNAPPLIED_DISCOUNT_CODE") : cart.appliedCartDiscounts;
  if (isReadOnly && !appliedDiscounts.length) return null;
  return /* @__PURE__ */ React.createElement("section", { className: "voucher-codes" }, isReadOnly ? /* @__PURE__ */ React.createElement("div", { className: "voucher-codes__heading", "data-t": "voucher-codes-heading" }, /* @__PURE__ */ React.createElement(H4, { className: "voucher-codes__heading-title", variant: "heading-smallest" }, getLabel("cart.discounts.applied"))) : /* @__PURE__ */ React.createElement(Accordion, { className: "voucher-codes__acc" }, /* @__PURE__ */ React.createElement(
    AccordionItem,
    {
      id: "discount-code",
      className: "voucher-codes__acc__item",
      label: getLabel("cart.discountForm.title"),
      headingLevel: "h4"
    },
    /* @__PURE__ */ React.createElement(
      VoucherCodeFormContainer,
      {
        className: "voucher-codes__acc__form",
        cartId: cart.id,
        inputId: "discount-code"
      }
    )
  )), /* @__PURE__ */ React.createElement(AppliedDiscounts, { appliedCartDiscounts: appliedDiscounts, isReadOnly }));
};
export {
  VoucherCodesLayout
};
//# sourceMappingURL=VoucherCodesLayout.js.map
